<div class="btn-container">
	<button [ngClass]="{'filters-applied': showAppliedFiltersCount}" mat-flat-button
		class="pointer filters font-weight-500" (click)="manageFilterModal(!opened)">
		<mat-icon>filter_list</mat-icon>
		<span class="title2">{{'general.filters' | translateWithKeys}}</span>
		@if (showAppliedFiltersCount) {
		<span class="title2 pl-5">({{ activeFiltersCount }})</span>
		<button mat-icon-button (click)="clearFilters(); $event.stopPropagation()">
			<mat-icon>close</mat-icon>
		</button>
		}
	</button>
</div>

@if (opened) {
<div class="modal-container">
	<div class="media-overflow height">
		<h2 class="title">{{'general.filters' | translateWithKeys}}</h2>
		<div class="row mb-24 " [ngClass]="{'mt-16': activeFilterChips.length}">
			<mat-chip-set aria-label="Selected filters">
				@for (chip of activeFilterChips.slice(0, 3); track $index) {
				<mat-chip>
					{{ chip.label }}: {{ chip.value }}
					<button matSuffix mat-icon-button aria-label="Remove" (click)="chip.removeFn()">
						<mat-icon svgIcon="close_black" class="delete-filter-icon"></mat-icon>
					</button>
				</mat-chip>
				}
				@if (activeFilterChips.length > 3) {
				<mat-chip matTooltip="{{ extraFilterChips }}">
					+{{ activeFilterChips.length - 3 }} {{ 'general.more' | translateWithKeys }}
					<button mat-icon-button (click)="clearExtraChips()" aria-label="Clear extra filters">
						<mat-icon svgIcon="close_black" class="delete-filter-icon"></mat-icon>
					</button>
				</mat-chip>
				}


			</mat-chip-set>
		</div>
		<hr>
		<div class="row gap mt-24">
			@if (filterByLanguages) {
			<mat-form-field class="select-language" appearance="outline">
				<mat-select placeholder="{{'general.language' | translateWithKeys}}" multiple
					[(value)]="languageSelected" [panelWidth]="null" #langSelect="matSelect">
					<mat-select-trigger>
						{{ 'general.language' | translateWithKeys }}
					</mat-select-trigger>

					@for (language of languagesList; track $index) {
					<mat-option [value]="language">
						{{ language.name | translateWithKeys }}
					</mat-option>
					}
				</mat-select>

				<mat-icon matSuffix svgIcon="drop_icon" class="transition-icon"
					[class.rotated]="langSelect.panelOpen"></mat-icon>
			</mat-form-field>
			}
			@if (filterByPublishStatus) {
			<mat-form-field class="select-language" appearance="outline">
				<mat-select placeholder="{{'general.status' | translateWithKeys}}" multiple [panelWidth]="null">
					<mat-option [value]="publishStatus.PUBLISHED">{{ 'general.published' |
						translateWithKeys}}</mat-option>
					<mat-option [value]="publishStatus.DRAFT">{{ 'general.draft' | translateWithKeys}}</mat-option>
				</mat-select>
			</mat-form-field>
			}
			@if (customFilters) {
			@for (filter of customFilters; track $index) {
			<mat-form-field class="select-language" appearance="outline">
				<mat-select [placeholder]="filter.name | translateWithKeys" multiple [(value)]="filter.selectedOptions" [panelWidth]="null">
					<mat-select-trigger>
						{{ filter.name | translateWithKeys }}
					</mat-select-trigger>

					@for (option of filter.options; track $index) {
					<mat-option [value]="option">
						{{ option.toString()| translateWithKeys }}
					</mat-option>
					}
				</mat-select>
			</mat-form-field>
			}
			}
			@if(filterByDate) {
			<mat-form-field appearance="outline">
				<mat-label class="flex height-38 text-accent">{{ 'general.date_range' | translateWithKeys }}</mat-label>
				<mat-date-range-input [rangePicker]="picker">
					<input matStartDate placeholder="{{ 'general.start_date' | translateWithKeys }}"
						[(ngModel)]="dateRange.startDate">
					<input matEndDate placeholder="{{ 'general.end_date' | translateWithKeys }}"
						[(ngModel)]="dateRange.endDate">
				</mat-date-range-input>
				<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-date-range-picker #picker></mat-date-range-picker>
			</mat-form-field>
			}

		</div>
	</div>
	<div class="btn-modal-container">
		<button class="view-btn btn-border title2" mat-flat-button
			(click)="manageFilterModal(!opened)">{{'general.cancel' | translateWithKeys}}</button>
		<button class="view-btn btn-size btn-primary title2" mat-flat-button color="primary"
			(click)="applyFilters()">{{'general.apply_filters' | translateWithKeys}}</button>
	</div>
</div>
}